import React from 'react';
import useBellNotification from 'hooks/API/GET/useBellNotification';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import MarkunreadOutlinedIcon from '@material-ui/icons/MarkunreadOutlined';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ChatBubbleIcon from '@material-ui/icons/ChatBubble';
import Tooltip from '@material-ui/core/Tooltip';
import useManageBellNotification from 'hooks/API/useManageBellNotification';

function UserActionCenter(props) {
  const { isLoading, data, isError } = useBellNotification({ enabled: true });
  const results = data?.data || [];

  const { isLoading: isUpdating, mutate } = useManageBellNotification();

  function handleMarkAsRead(args = {}) {
    if (isLoading) return;
    if (isUpdating) return;

    mutate(args);
  }

  return (
    <div className="mainWraper">
      {isLoading ? (
        'Loading...'
      ) : isError ? (
        'Failed to load data'
      ) : (
        <>
          <div>
            {results?.length > 0 ? (
              <>
                {results?.map((item) => {
                  const { date, commentId } = item || {};
                  const { commentAdded, subtopic, topic, chapter, course } = item?.labels || {};
                  let __href = `/classes/${item.classId}/courses/${item.course}/chapters/${item.chapter}/topics/${item.topic}/contentPreview?lessonType=notes&open=note&utm_source=review-tiles`;
                  if (item?.subtopic) __href += `&subtopic=${item.subtopic}`;
                  if (commentId) __href += `&replyCommentHash=${commentId}`;

                  function handleGoto(to) {
                    if (to) props?.history?.push(to);
                  }

                  return (
                    <div key={commentId} className="d-flex">
                      <div>
                        <ListItemAvatar>
                          <ListItemIcon>
                            <ChatBubbleIcon />
                          </ListItemIcon>
                        </ListItemAvatar>
                      </div>
                      <div>
                        <ListItem component="a" href={__href}>
                          <ListItemText
                            primary={`A new comment has been added by ${commentAdded} for the title ${
                              subtopic || topic
                            } under ${chapter} of ${course}`}
                            secondary={date}
                          />
                        </ListItem>
                      </div>
                      <div>
                        <Tooltip title="Mark as read">
                          <ListItemButton
                            edge="end"
                            aria-label="delete"
                            onClick={() => {
                              handleMarkAsRead({ id: commentId });
                            }}
                          >
                            <MarkunreadOutlinedIcon />
                          </ListItemButton>
                        </Tooltip>
                      </div>
                    </div>
                  );
                })}
              </>
            ) : null}
          </div>
        </>
      )}
    </div>
  );
}

export default UserActionCenter;
